/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccessConditionEffect } from '../models/AccessConditionEffect';
import { AccessConditionalExpression } from '../models/AccessConditionalExpression';
import { Condition } from '../models/Condition';

export class AccessCondition {
  /**
  * Display name for the data access rule, which also serves as its ID for use in `permissionGrants`. Valid characters: `[a-zA-Z0-9-_.\\s]`. 
  */
  'id': string;
  'condition'?: Condition;
  'effect': AccessConditionEffect;
  'expression': AccessConditionalExpression | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "condition",
      "baseName": "condition",
      "type": "Condition",
      "format": ""
    },
    {
      "name": "effect",
      "baseName": "effect",
      "type": "AccessConditionEffect",
      "format": ""
    },
    {
      "name": "expression",
      "baseName": "expression",
      "type": "AccessConditionalExpression",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AccessCondition.attributeTypeMap;
  }

  public constructor() {
  }
}



